var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H100V100H0ZM0,0H100V100H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.579,23.257l-25.1,25.1L18.8,34.723l-5.371,5.371L32.475,59.141,62.951,28.666ZM40.094,2A38.094,38.094,0,1,0,78.188,40.094,38.108,38.108,0,0,0,40.094,2Zm0,68.57A30.475,30.475,0,1,1,70.57,40.094,30.467,30.467,0,0,1,40.094,70.57Z",
    transform: "translate(9.906 9.906)",
    fill: "#27BF2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmTx);
export default __webpack_public_path__ + "static/media/confirm-tx.11f6312d65d8357acd974d065ce0b45f.svg";
export { ForwardRef as ReactComponent };